import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

const Footer = () => {
  const [loggedIn, setLoggedIn] = useState(false);
  const [isMobileView, setIsMobileView] = useState(false);

  useEffect(() => {
    setLoggedIn(!!sessionStorage.getItem("token"));

    const handleResize = () => setIsMobileView(window.innerWidth <= 767);
    handleResize();

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const showAbout = !loggedIn || isMobileView;
  const showLinks = !loggedIn;
  const showContact = !loggedIn;

  return (
    <footer className="footer">
      <div className="footer-grid">
        <div className="footer-spacer"></div>

        {showAbout && (
          <div className="footer-block">
            <h3>About Core Bankers</h3>
            <p>
              Core Bankers is a brand of VedhaNirvana Private Limited. We are a
              Direct Selling Agent partnering with leading banks and NBFCs for
              personal, business, home, and vehicle loan solutions.
            </p>
          </div>
        )}

        {showLinks && (
          <div className="footer-block">
            <h3>Quick Links</h3>
            <ul>
              <li>
                <Link to="/about">About Us</Link>
              </li>
              <li>
                <Link to="/eligibility">Check Eligibility</Link>
              </li>
              <li>
                <Link to="/contact">Contact Us</Link>
              </li>
              <li>
                <Link to="/careers">Careers</Link>
              </li>
              <li>
                <Link to="/consent-policy">Consent Policy</Link>
              </li>
              <li>
                <Link to="/terms">Terms & Conditions</Link>
              </li>
              <li>
                <Link to="/privacy">Privacy Policy</Link>
              </li>
            </ul>
          </div>
        )}

        {showContact && (
          <div className="footer-block">
            <h3>Contact</h3>
            <p>
              Core Bankers, VedhaNirvana Pvt Ltd
              <br />
              8th Floor, South Towers, KRM Plaza
              <br />
              Harrington Road, Chetpet, Chennai
              <br />
              Tamil Nadu - 600031
              <br />
              +91 86394 15052
              <br />
              Manager@CoreBankers.in
            </p>
          </div>
        )}

        <div className="footer-spacer"></div>
      </div>

      <div className="footer-copy">
        © {new Date().getFullYear()} Core Bankers by VedhaNirvana Private Ltd.
        All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
